export const DEFAULT_GAME_CONFIG = {
    skinId: 'diver',
    progressDuration: 12_000,
};